import {appPagePaths, isSevenDayTrialEnabled} from "../config/config";
import {navigate} from "../services/navigation/navigation";

export interface ITrialNavigationHook {
  navigateToAppropriateAccountCreationPage: () => void;
}

export const useTrialNavigation = (): ITrialNavigationHook => {
  const appropriatePage = isSevenDayTrialEnabled
    ? appPagePaths.createTrialAccountPage
    : appPagePaths.createAccountPage;

  return {
    navigateToAppropriateAccountCreationPage: () => navigate(appropriatePage),
  };
}
